const data = [
  {
    responsive_id: '',
    id: 95,
    full_name: 'Edwina Ebsworth',
    action: 'Nso Diaspora Association',
    amount: '10,000 XAF',
    profit: '10, 000 XAF',
    commission: '100 XAF',
    status: 'Deposit',
    date_time: 'Fridat, 5 Jan. 2022 - 11:13 PM',
  },
  {
    responsive_id: '',
    id: 1,
    full_name: "Korrie O'Crevy",
    action: 'New Vision Excellence',
    amount: '1,000,000 XAF',
    profit: '50, 000 XAF',
    commission: '5000 XAF',
    status: 'Withdrawal',
    date_time: 'Wednesday, 5 Jan. 2021 - 11:03 AM',
  },
  {
    responsive_id: '',
    id: 7,
    full_name: "Falloon O'De",
    action: 'PSS Mankon Ex-Students Association',
    amount: '500,000 XAF',
    profit: '30, 000 XAF',
    commission: '3000 XAF',
    status: 'Deposit',
    date_time: 'Wednesday, 5 Jan. 2021 - 10:13 AM',
  },
  {
    responsive_id: '',
    id: 3,
    full_name: 'Stella Ganderton',
    action: 'PSS Mankon Ex-Students Association',
    amount: '35,000 XAF',
    profit: '3000 XAF',
    commission: '300 XAF',
    status: 'Deposit',
    date_time: 'Wednesday, 5 Jan. 2021 - 11:00 AM',
  },
  {
    responsive_id: '',
    id: 4,
    full_name: 'Dorolice Crossman',
    action: 'Babanki Womens Empowerment',
    amount: '17,000 XAF',
    profit: '2000 XAF',
    commission: '200 XAF',
    status: 'Deposit',
    date_time: 'Friday, 5 Jan. 2021 - 09:13 PM',
  },
]

export default data
